
            const data = {"name":"arrow","data":{"width":"28","height":"16","viewBox":"0 0 28 16","data":"<path pid=\"0\" d=\"M27.707 8.707a1 1 0 0 0 0-1.414L21.343.929a1 1 0 1 0-1.414 1.414L25.586 8l-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364ZM0 9h27V7H0v2Z\" _fill=\"#5138EE\"/>","originalColors":[{"type":"fill","color":"#5138EE"}],"stopColors":[]}}
        
                    module.exports = data
                    